import { useCallback, useRef } from "react";

import Collapse from "../Utils/Collapse";
import CollapseContent from "../Utils/CollapseContent";
import CollapseSwitch from "../Utils/CollapseSwitch";
import { useAuthenticationCollapsibleFormsContext } from "./AuthenticationCollapsibleFormsContext";

const AuthenticationCollapsibleForm = props => {
  const { children, type, label } = props;
  const contentContainerRef = useRef();

  const { selectedAuthOption, setSelectedAuthOption } =
    useAuthenticationCollapsibleFormsContext();

  const expanded = selectedAuthOption === type;

  const shouldCollapse = useCallback(
    () => !!selectedAuthOption && selectedAuthOption !== type,
    [selectedAuthOption, type]
  );

  const handleExpandedChanged = useCallback(
    willExpand => {
      setTimeout(() => {
        if (!contentContainerRef.current) return;

        // Focus the first input of the form when it is expanded, to improve accessibility
        // and usability for keyboard and screen reader users.
        contentContainerRef.current.querySelector("input")?.focus();
      }, 300);

      setSelectedAuthOption(currentAuthOption => {
        if (willExpand) return type;
        if (currentAuthOption === type) return null;

        return currentAuthOption;
      });
    },
    [setSelectedAuthOption, type]
  );

  return (
    <Collapse
      expanded={expanded}
      shouldCollapse={shouldCollapse}
      onExpandedChanged={handleExpandedChanged}
    >
      <CollapseSwitch
        className="btn btn-primary-inverse btn-block-md box-shadow-lg margin-bottom-xs"
        label={label}
        data-authentication-type-button={type}
      />

      <CollapseContent className="margin-bottom-xs" ref={contentContainerRef}>
        {children}
      </CollapseContent>
    </Collapse>
  );
};

export default AuthenticationCollapsibleForm;
